import { Component,OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { Http, Response} from '@angular/http';

//service
import { AppSharedService  } from '../service/app_shared';

//types
import { AboutViewModel} from '../model/types'

@IonicPage()
@Component({
  selector: 'page-about',
  templateUrl: 'about.html',
})
export class AboutPage implements OnInit {

  aboutUs:AboutViewModel;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private appSharedService:AppSharedService,
    private http: Http,
    public loadingCtrl : LoadingController,
    ) {

      this.aboutUs={
          About:"",
          CompanyName:"",
          ContactNumber:"",
          Email:"",
          Rules:"",
          WebSite:""
      }
  }

  //initalization
  ngOnInit(){
   this.GetAboutUs();
  }

  GetAboutUs(){
    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    // show loader
    loading.present();
    
    var url=(this.appSharedService.configInfo.applicationInfo.apiBasePath+'/'+this.appSharedService.configInfo.urlInfo.urlGetAboutUs);

    // get banner
    this.http.get(url)
        .map((data : Response) =>{
                return data.json() as AboutViewModel;
            }).toPromise().then(x => {                  
              // assign response variable                              
              this.aboutUs=x;
                  // show loader
              loading.dismiss();
            });
      }  

  }





// WEBPACK FOOTER //
// ./src/pages/about/about.ts